import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';

export default function Shimmer() {
  return (
    <Container maxWidth="xxl" sx={{ mb: 4 }}>
      {/* <Paper elevation={10} sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}> */}
        <Stack spacing={2}>
          {/* For variant="text", adjust the height via font-size */}
          <Skeleton variant="text" sx={{ fontSize: '3rem' }} animation="wave" />
          {/* For other variants, adjust the size with `width` and `height` */}
          <Skeleton variant="rectangular" width={500} height={30} animation="wave" />
          <Skeleton variant="rectangular" width={350} height={30} animation="wave" />
          <Skeleton variant="rectangular" width={350} height={30} animation="wave" />
        </Stack>
      {/* </Paper> */}
    </Container>
  );
}